// ========== GET METHODS ==========
export const userRegisterByMonthStatisticsApi = () => 'statistics/users/register-by-month/'
